module.exports = __webpack_public_path__ + "static/facebook_card-e17d757228a95f96a78fa24885ff7657.png";